module.exports = __webpack_public_path__ + "static/media/pay_havale.95f3b92d.svg";